import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchCurrentNda() {
  const { data } = await axios.get(`${API}/nda/current`);
  return data;
}

export async function fetchNdaDocument(version) {
  const { data } = await axios.get(`${API}/nda/document/${encodeURIComponent(version)}`);
  return data;
}

export async function fetchNdaStatus() {
  const { data } = await axios.get(`${API}/nda/status`);
  return data;
}

export async function fetchNdaAcceptances() {
  const { data } = await axios.get(`${API}/nda/acceptances`);
  return data;
}

export async function postAcceptNda(version) {
  const { data } = await axios.post(`${API}/nda/accept`, { version });
  return data;
}
